import React, { useEffect, useState } from "react";
import oldData from "../../assets/data/Applicant";
import { useNavigate, useParams } from "react-router-dom";
import DefaultLayout from "../../layout/DefaultLayout";
import Loadings from "../../components/Loadings/Loadings";
import { FiChevronLeft, FiChevronRight, FiSend } from "react-icons/fi";
import QualificationModal from "../../components/Modal/PreQualification/QualificationModal";
import PrequaliModal from "../../components/Modal/ApplicantDetail/PrequaliModal";
import { toast } from "react-hot-toast";
import useHelmet from "../../components/hooks/useHelmet";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import TooltipPM from "../../components/Tooltip/TooltipPM";
import HireModal from "../../components/Modal/ApplicantDetail/HireModal";
import DeclineModal from "../../components/Modal/ApplicantDetail/DeclineModal";
import RejectOthersModal from "../../components/Modal/ApplicantDetail/RejectOthersModal";
import RemoveModal from "../../components/Modal/ApplicantDetail/RemoveModal";
import EmailModal from "../../components/Modal/ApplicantDetail/EmailModal";
import Tooltip from "../../components/Tooltip/Tooltip";

//icons
import removeuser from "../../assets/images/icons/remove-user.png";
import pen from "../../assets/images/icons/pen.png";
import hired from "../../assets/images/icons/hired.png";
import change from "../../assets/images/icons/change.png";
import cancel from "../../assets/images/icons/cancel.png";
import { BsCalendarPlusFill, BsFillSendFill } from "react-icons/bs";
import { FaUserTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import TaskConsts from "constants/TaskConsts";
import fetchUtils from 'utils/fetchData';

export default function HiredApplicant() {
    const { id } = useParams();

    const [data, setData] = useState([]);
    const [buttonPressed, setButtonPressed] = useState(false);
    const [applicantsData, setApplicantsData] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [rowCount, setRowCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [newData, setNewData] = useState([]);
    const [sortedData, setSortedData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [counter, setCounter] = useState(0);
    const [topScorer, setTopScorer] = useState();
    const [sortAndSlice, setSortAndSlice] = useState();
    const [oldNewData, setOldNewData] = useState([]);

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalHireIsOpen, setModalHireIsOpen] = useState(false);
    const [modalDeclineIsOpen, setModalDeclineIsOpen] = useState(false);
    const [modalRemoveIsOpen, setModalRemoveIsOpen] = useState(false);
    const [modalOthersIsOpen, setModalOthersIsOpen] = useState(false);
    const [modalEmailIsOpen, setModalEmailIsOpen] = useState(false);
    const [subject, setSubject] = useState("");
    const [to, setTo] = useState("");
    const [message, setMessage] = useState("");
    const [consolidated, setConsolidated] = useState();
    const [hasHired, setHasHired] = useState(false);

    const [modalIsOpenSchedule, setModalIsOpenSchedule] = useState(false);

    const MySwal = withReactContent(Swal);

    const [currentId, setCurrentId] = useState("");

    useHelmet("Stage 3: Consolidated Scoring - HRIS");

    const [myVariable, setMyVariable] = useState("");

    const user = `${window.globalConfig.BASE_URL2}/api/Users`;
    const jobPositions = `${window.globalConfig.BASE_URL2}/api/JobPositions`;
    const email = `${window.globalConfig.BASE_URL2}/api/Email`;
    const onboarding = `${window.globalConfig.BASE_URL2}/api/EmployeesForOnBoardings`;
    const EmployeeRoleId = window.globalConfig.EMPLOYEE_ROLE;

    const navigate = useNavigate();

    useEffect(() => {
        let variableValue;
        const cookies = document.cookie.split(";"); //Get all cookies as an array

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();

            //Check if the cookie contains the variable you're looking for
            if (cookie.startsWith("ID=")) {
                variableValue = cookie.substring("ID=".length, cookie.length);
                setMyVariable(variableValue);
                break;
            }
        }
    }, []);

    useEffect(() => {
        if (data?.rows && data.rows.length > 0) {
            if (!data?.rows[0]?.archivedDate) {
                //navigate(-1, { replace: true });
            }
        }
    }, [data]);

    const handleQualify = async (e) => {
        e.preventDefault();
        const ApplicantID = sortedData?.filter((item) => item.selected === true);
        try {
            const response = await fetch(`${jobPositions}/Qualify`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                mode: "cors",
                credentials: "include",
                body: JSON.stringify({
                    to: to,
                    subject: subject,
                    body: message.replace(/\n/g, "<br>"),
                    applicantID: sortedData?.filter((item) => item.selected === true)[0]
                        .id,
                    disqualify: false,
                    jobPositionID: id,
                }),
            });
            const getScoreItems = await fetch(`${jobPositions}/SaveApplication`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    applicantID: sortedData?.filter((item) => item.selected === true)[0]
                        .id,
                    jobPositionID: id,
                    status: 5,
                }),
            });
            const data = await getScoreItems.json();
            const updatedArray2 = sortedData
                .filter((item) => item.Status > 2)
                .map((item) => {
                    if (
                        item.id ===
                        sortedData?.filter((item) => item.selected === true)[0].id
                    ) {
                        return { ...item, Status: 5 };
                    }
                    return { ...item };
                });
            setSortedData(updatedArray2);
            MySwal.fire({
                icon: "success",
                title: "Email Successfully Sent",
                //text: "The status has been changed.",
                confirmButtonText: "Ok",
            }).then((results) => {
                if (results.isConfirmed) {
                }
            });
        } catch (error) {
            console.log(error);
        } finally {
            setModalIsOpen(!modalIsOpen);
            //navigate(`/stage-1:-delisting/${id2}`);
        }
    };

    const handleButtonClick = async (applicantId) => {
        try {
            const response2 = await fetch(`${user}/GetSingle`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                mode: "cors",
                credentials: "include",
                body: JSON.stringify({
                    id: myVariable,
                }),
            });
            const data2 = await response2.json();
            const response = await fetch(`${jobPositions}/GetQualificationMessage`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    applicantID: applicantId,
                    disqualify: false,
                    jobPositionID: id,
                }),
            });
            setCurrentId(applicantId);
            const jsonData = await response.json();
            setTo(jsonData.to);
            setMessage(jsonData.body);
            setSubject(jsonData.subject);
        } catch (error) {
        } finally {
            setModalIsOpen(!modalIsOpen);
        }
    };
    const fetchData = async () => {
        try {
            const pConsolidated = await fetchUtils.Post('/api/exam/GetConsolidated', {
                JobPositionID: id
            });
            pConsolidated.applicants.map((item, index) => item.rank = index + 1);
            var pHasHired = pConsolidated.applicants.some(x => x.status == 'Hired');
            setHasHired(pHasHired);
            setConsolidated(pConsolidated);

            const response = await fetch(`${jobPositions}/Get`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ id }),
            });

            if (!response.ok) {
                throw new Error("Error fetching data");
            }

            const jsonData = await response.json();
            setData(jsonData);
            const response2 = await fetch(`${user}/Get`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ id: null, jobPositionID: id }),
            });

            if (!response.ok) {
                throw new Error("Error fetching data");
            }

            const jsonData2 = await response2.json();
            setApplicantsData({
                rows: jsonData2.rows,
            });
            setRowCount(jsonData2.rows?.length);
            if (
                jsonData2.rows?.filter((item) => item.jobApplicationStatus > 2)
                    .length === 0
            ) {
                setIsLoading(false);
            }
        } catch (error) {
            console.log(error);
            if (error.message === "Error fetching data") {
                navigate("/prequalification-table");
            }
        } finally {
            //setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [id]);

    const handleRowsPerPage = (e) => {
        setRowsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleNextPage = () => {
        const lastPage = Math.ceil(rowCount / rowsPerPage);
        if (currentPage < lastPage) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    const handleBackPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    const [selected, setSelected] = useState(false);
    const toggleSelected = (id) => {
        const updateddata = sortedData.map((item) => {
            if (item.id === id) {
                return { ...item, selected: !item.selected };
            }
            return { ...item };
        });
        setSortedData(updateddata);
    };

    const updatedItems = oldData.map((item, index) => ({
        ...item,
        selected,
    }));
    const [data1, setData1] = useState(updatedItems);

    useEffect(() => {
        setData1(updatedItems);
    }, [oldData]);

    const handleCloseModal = () => {
        setCurrentId("");
        setModalIsOpen(false);
        setModalHireIsOpen(false);
        setModalDeclineIsOpen(false);
        setModalOthersIsOpen(false);
        setModalRemoveIsOpen(false);
        setModalEmailIsOpen(false);
        setTo("");
        setSubject("");
        setMessage("");
    };

    useEffect(() => {
        applicantsData?.rows
            ?.filter((item) => item.jobApplicationStatus > 2)
            ?.map(async (item) => {
                await fetchScoreData(item.id).then((result) => {
                    const updatedItems = applicantsData.rows
                        .filter((row) => row.id === item.id)
                        .map((row) => {
                            if (row.id === item.id) {
                                return {
                                    ...row,
                                    TotalScore: result[result.length - 1],
                                    Status: row.jobApplicationStatus,
                                    Result: result,
                                    PracticalScore:
                                        Math.round(
                                            result
                                                .slice(0, result.length - 1)
                                                .reduce(
                                                    (acc, curr) =>
                                                        acc + Math.round(curr.pointsValue * 100) / 100,
                                                    0
                                                ) * 100
                                        ) / 100,
                                };
                            }
                        });
                    setNewData((prevData) => {
                        const itemExists = prevData?.some(
                            (row) => row.id === updatedItems[0].id
                        );
                        if (!itemExists) {
                            return [...prevData, updatedItems[0]];
                        }
                        return prevData;
                    });
                    setCounter(counter + 1);
                });
            });
    }, [rowCount]);

    useEffect(() => {
        const ranked = sortedData
            ?.filter((item) => item.Status > 2)
            ?.sort((a, b) => b.PracticalScore - a.PracticalScore);

        let currentRank = 1;
        let rankAdder = 0;
        let currentPoints = ranked.length > 0 ? ranked[0].PracticalScore : 0;
        const nomineesWithRank = ranked.map((item, index) => {
            if (item.PracticalScore < currentPoints) {
                currentRank += rankAdder;
                currentPoints = item.PracticalScore;
                rankAdder = 1;
            } else if (item.PracticalScore === currentPoints) {
                rankAdder++;
            }
            return { ...item, rank: currentRank };
        });
        setSortAndSlice(nomineesWithRank);
    }, [sortedData]);

    useEffect(() => {
        const sortedPeople = [...newData].sort(
            (personA, personB) => personB.TotalScore - personA.TotalScore
        );
        setSortedData(sortedPeople);
        setOldNewData(sortedPeople);
    }, [newData]);

    const fetchScoreData = async (id2) => {
        try {
            const getScoreItems = await fetch(`${jobPositions}/GetScoreItems`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    applicantID: id2,
                    disqualify: false,
                    jobPositionID: id,
                    stage: 1,
                }),
            });
            const data = await getScoreItems.json();
            const totalScore = data.reduce((acc, curr) => acc + curr.pointsValue, 0);
            const response3 = await fetch(`${jobPositions}/GetScoreItems`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    applicantID: id2,
                    jobPositionID: id,
                    disqualify: false,
                    stage: 2,
                }),
            });
            const jsonData3 = await response3.json();
            setHeaders(jsonData3);
            // const response2 = await fetch(`${jobPositions}/GetApplication`, {
            //   method: "POST",
            //   mode: "cors",
            //   credentials: "include",
            //   headers: {
            //     "Content-Type": "application/json",
            //   },
            //   body: JSON.stringify({
            //     applicantID: id2,
            //     jobPositionID: id,
            //     disqualify: false,
            //   }),
            // });
            // const jsonData2 = await response2.json();
            const finaldata = jsonData3.concat(totalScore);
            // .concat(jsonData2.status);
            return finaldata;
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleButtonClickDisqualify = async () => {
        const ApplicantID = sortedData?.filter((item) => item.selected === true);
        try {
            if (ApplicantID.length === 0) {
                throw new Error("Error fetching data");
            }
            const response = await fetch(`${jobPositions}/GetQualificationMessage`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    applicantID: sortedData?.filter((item) => item.selected === true)[0]
                        .id,
                    disqualify: false,
                    jobPositionID: id,
                }),
            });
            const jsonData = await response.json();
            setTo(jsonData.to);
            setMessage(jsonData.body);
            setSubject(jsonData.subject);
            setModalIsOpen(!modalIsOpen);
        } catch (error) {
            //console.log(error.message);
            if (error.message === "Error fetching data") {
                toast.error("Select An Applicant.");
            }
        } finally {
        }
    };
    const handleButtonHire = async () => {
        const ApplicantID = sortedData?.filter((item) => item.selected === true);
        try {
            if (ApplicantID.length === 0) {
                throw new Error("Error fetching data");
            }
            const response = await fetch(`${user}/ComposeEmail`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    userID: sortedData?.filter((item) => item.selected === true)[0].id,
                    templateNum: 3,
                }),
            });
            const jsonData = await response.json();
            setTo(jsonData.to);
            setMessage(jsonData.body);
            setSubject(
                data?.rows[0].name + " (" + data?.rows[0].plantillaItemNum + ")"
            );
            setModalHireIsOpen(!modalHireIsOpen);
        } catch (error) {
            //console.log(error.message);
            if (error.message === "Error fetching data") {
                toast.error("Select An Applicant.");
            }
        } finally {
        }
    };
    const handleButtonDecline = async () => {
        const ApplicantID = sortedData?.filter((item) => item.selected === true);
        try {
            if (ApplicantID.length === 0) {
                throw new Error("Error fetching data");
            }
            const response = await fetch(`${user}/ComposeEmail`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    userID: sortedData?.filter((item) => item.selected === true)[0].id,
                    templateNum: 2,
                }),
            });
            const jsonData = await response.json();
            setTo(jsonData.to);
            setMessage(jsonData.body);
            setSubject(
                data?.rows[0].name + " (" + data?.rows[0].plantillaItemNum + ")"
            );
            setModalDeclineIsOpen(!modalDeclineIsOpen);
        } catch (error) {
            //console.log(error.message);
            if (error.message === "Error fetching data") {
                toast.error("Select An Applicant.");
            }
        } finally {
        }
    };
    const handleButtonRemove = async () => {
        const ApplicantID = sortedData?.filter((item) => item.selected === true);
        try {
            if (ApplicantID.length === 0) {
                throw new Error("Error fetching data");
            }
            const response = await fetch(`${user}/ComposeEmail`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    userID: sortedData?.filter((item) => item.selected === true)[0].id,
                    templateNum: 6,
                }),
            });
            const jsonData = await response.json();
            setTo(jsonData.to);
            setMessage(jsonData.body);
            setSubject(
                data?.rows[0].name + " (" + data?.rows[0].plantillaItemNum + ")"
            );
            setModalRemoveIsOpen(!modalRemoveIsOpen);
        } catch (error) {
            //console.log(error.message);
            if (error.message === "Error fetching data") {
                toast.error("Select An Applicant.");
            }
        } finally {
        }
    };

    const sorting = (value) => {
        if (!oldNewData) {
            setOldNewData(sortedData);
        }
        if (value) {
            setTopScorer(value.replace(/[^0-9,]/g, "").replace(/,/g, ""));
            const sortedPeople = [...oldNewData]
                .filter((item) => item.Status > 2)
                .sort(
                    (personA, personB) => personB.PracticalScore - personA.PracticalScore
                );
            const topOldest = [];
            let count = 0;
            let prevScore = null;
            for (const person of sortedPeople) {
                if (
                    count === parseInt(value.replace(/[^0-9,]/g, "").replace(/,/g, "")) &&
                    person.PracticalScore !== prevScore
                ) {
                    break;
                } else if (
                    count === parseInt(value.replace(/[^0-9,]/g, "").replace(/,/g, "")) &&
                    person.PracticalScore == prevScore
                ) {
                    topOldest.push(person);
                } else {
                    topOldest.push(person);
                    count++;
                }
                //if (prevScore === null || person.TotalScore <= prevScore) {
                //}

                prevScore = person.PracticalScore;
            }
            setSortedData(topOldest);
        } else {
            setTopScorer();
            if (oldNewData) {
                setSortedData(oldNewData);
            }
        }
    };

    const handleDeclined = async () => {
        const ApplicantID = sortedData?.filter((item) => item.selected === true);
        try {
            if (ApplicantID.length === 0) {
                throw new Error("Error fetching data");
            }
            const response = await fetch(`${email}/Send`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                mode: "cors",
                credentials: "include",
                body: JSON.stringify({
                    body: message.replace(/\n/g, "<br>"),
                    subject,
                    to,
                }),
            });
            const data2 = await response.text();
            if (data2) {
                throw new Error("Failed to send email.");
            }
            const getScoreItems = await fetch(`${jobPositions}/SaveApplication`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    applicantID: sortedData?.filter((item) => item.selected === true)[0]
                        .id,
                    jobPositionID: id,
                    status: 3,
                }),
            });
            const response3 = await fetch(`${jobPositions}/Hire`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                mode: "cors",
                credentials: "include",
                body: JSON.stringify({
                    applicantID: sortedData?.filter((item) => item.selected === true)[0]
                        .id,
                    hire: false,
                    jobPositionID: id,
                }),
            });
            const data = await getScoreItems.json();
            const updatedArray1 = sortedData
                .filter((item) => item.Status > 2)
                .map((item) => {
                    if (
                        item.id ===
                        sortedData?.filter((item) => item.selected === true)[0].id
                    ) {
                        return { ...item, Status: 3, hiredDate: null };
                    }
                    return { ...item };
                });
            setSortedData(updatedArray1);
            if (sessionStorage.getItem("PreQualificationTable")) {
                const counter = JSON.parse(
                    sessionStorage.getItem("PreQualificationTable")
                );
                const updatedArray1 = counter.rows.map((item) => {
                    if (
                        item.id === id &&
                        sortedData?.filter((item) => item.selected === true)[0].hiredDate
                    ) {
                        return { ...item, lastestHiredDate: null };
                    }
                    return item;
                });
                sessionStorage.setItem(
                    "PreQualificationTable",
                    JSON.stringify({ rows: updatedArray1 })
                );
                document.cookie = `PrequaTablePage=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            }
            setModalDeclineIsOpen(false);
            toast.success("Email Sent Successfuly");
            setTo("");
            setMessage("");
            setSubject("");
        } catch (error) {
            //console.log(error.message);
            if (error.message === "Error fetching data") {
                toast.error("Select An Applicant.");
            }
        } finally {
        }
    };
    const handleDeclinedOthers = async (e) => {
        e.preventDefault();
        const ApplicantID = sortedData?.filter(
            (item) => item.Status > 3 && item.selected !== true
        );
        try {
            ApplicantID.map(async (item) => {
                const response = await fetch(`${email}/Send`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    mode: "cors",
                    credentials: "include",
                    body: JSON.stringify({
                        body: message.replace(/\n/g, "<br>"),
                        subject,
                        to: item.email,
                    }),
                });
                const data2 = await response.text();
                if (data2) {
                    throw new Error("Failed to send email.");
                }
                const getScoreItems = await fetch(`${jobPositions}/SaveApplication`, {
                    method: "POST",
                    mode: "cors",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        applicantID: item.id,
                        jobPositionID: id,
                        status: 3,
                    }),
                });
                const response3 = await fetch(`${jobPositions}/Hire`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    mode: "cors",
                    credentials: "include",
                    body: JSON.stringify({
                        applicantID: item.id,
                        hire: false,
                        jobPositionID: id,
                    }),
                });
                const data = await getScoreItems.json();
            });
            const updatedArray1 = sortedData
                .filter((item) => item.Status > 2)
                .map((item) => {
                    if (
                        item.id ===
                        sortedData?.filter((item) => item.selected === true)[0].id
                    ) {
                        return { ...item, hiredDate: new Date(), Status: 6 };
                    }
                    return { ...item, hiredDate: null, Status: 3 };
                });
            setSortedData(updatedArray1);
            setMessage("");
            setTo("");
            setSubject("");
            setModalOthersIsOpen(false);
        } catch (error) {
            //console.log(error.message);
            if (error.message === "Error fetching data") {
                toast.error("Select An Applicant.");
            }
        } finally {
        }
    };
    const handleRemove = async () => {
        setButtonPressed(true);
        const ApplicantID = sortedData?.filter((item) => item.selected === true);
        try {
            if (ApplicantID.length === 0) {
                throw new Error("Error fetching data");
            }
            //const response = await fetch(`${email}/Send`, {
            //  method: "POST",
            //  headers: { "Content-Type": "application/json" },
            //  mode: "cors",
            //  credentials: "include",
            //  body: JSON.stringify({
            //    body: message.replace(/\n/g, "<br>"),
            //    subject,
            //    to,
            //  }),
            //});
            //const data2 = await response.text();
            //if (data2) {
            //  throw new Error("Failed to send email.");
            //}
            const getScoreItems = await fetch(`${jobPositions}/SaveApplication`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    applicantID: sortedData?.filter((item) => item.selected === true)[0]
                        .id,
                    jobPositionID: id,
                    status: 1,
                }),
            });
            const response3 = await fetch(`${jobPositions}/Hire`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                mode: "cors",
                credentials: "include",
                body: JSON.stringify({
                    applicantID: sortedData?.filter((item) => item.selected === true)[0]
                        .id,
                    hire: false,
                    jobPositionID: id,
                }),
            });
            const data = await getScoreItems.json();
            const updatedArray1 = sortedData.map((item) => {
                if (
                    item.id === sortedData?.filter((item) => item.selected === true)[0].id
                ) {
                    return { ...item, Status: 1, hiredDate: null };
                }
                return { ...item };
            });
            setSortedData(updatedArray1);
            setMessage("");
            setTo("");
            setSubject("");
            setModalRemoveIsOpen(false);
            toast.success("Applicant Successfuly Removed");
            if (sessionStorage.getItem("PreQualificationTable")) {
                const counter = JSON.parse(
                    sessionStorage.getItem("PreQualificationTable")
                );
                const updatedArray1 = counter.rows.map((item) => {
                    if (item.id === id) {
                        return { ...item, lastestHiredDate: null };
                    }
                    return item;
                });
                sessionStorage.setItem(
                    "PreQualificationTable",
                    JSON.stringify({ rows: updatedArray1 })
                );
                document.cookie = `PrequaTablePage=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            }
        } catch (error) {
            //console.log(error.message);
            if (error.message === "Error fetching data") {
                toast.error("Select An Applicant.");
            }
        } finally {
            setButtonPressed(false);
        }
    };
    const handleHire = async () => {
        setButtonPressed(true);
        const ApplicantID = sortedData?.filter(
            (item) => item.selected === true && !item.hiredDate
        );
        try {
            if (ApplicantID.length === 0) {
                throw new Error("Error fetching data");
            }
            let isNewEmployee = false;
            await MySwal.fire({
                icon: "info",
                title: "New Employee?",
                text: "Is this applicant a new employee?",
                confirmButtonText: "Yes",
                cancelButtonText: "Cancel",
                showCancelButton: true,
                showDenyButton: true,
                cancelButtonColor: "Red",
                denyButtonColor: "darkRed",
                confirmButtonColor: "green",
                allowOutsideClick: true,
                reverseButtons: false,
            }).then(async (results) => {
                if (results.isConfirmed) {
                    isNewEmployee = true;
                } else if (results.isDenied) {
                    isNewEmployee = false;
                } else if (results.isDismissed) {
                    throw new Error("error");
                }
                const response2 = await fetch(`${jobPositions}/Hire`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    mode: "cors",
                    credentials: "include",
                    body: JSON.stringify({
                        applicantID: sortedData?.filter((item) => item.selected === true)[0]
                            .id,
                        hire: true,
                        jobPositionID: id,
                    }),
                });
                const response2Text = await response2.text();
                if (response2.ok) {
                    toast.success('Employee was successfully hired.');
                    fetchData();
                } else {
                    toast.error(response2Text);
                    return;
                }
                if (isNewEmployee) {
                    const response3 = await fetch(`${onboarding}/Save`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        mode: "cors",
                        credentials: "include",
                        body: JSON.stringify({
                            EmployeeID: sortedData?.filter(
                                (item) => item.selected === true
                            )[0].id,
                            JobPositionID: id,
                            Phases: [
                                {
                                    ID: null, //blank for new. "19EB99B5-2B72-46A5-83B8-E0FDA0D5E4C9",
                                    Name: "Phase 1",
                                    DateFrom: "",
                                    DateTo: "",
                                    Status: "",
                                    DeletedFiles: [],
                                },
                                {
                                    ID: null, //blank for new. "19EB99B5-2B72-46A5-83B8-E0FDA0D5E4C9",
                                    Name: "Phase 2",
                                    DateFrom: "",
                                    DateTo: "",
                                    Status: "",
                                    DeletedFiles: [],
                                },
                                {
                                    ID: null, //blank for new. "19EB99B5-2B72-46A5-83B8-E0FDA0D5E4C9",
                                    Name: "Phase 3",
                                    DateFrom: "",
                                    DateTo: "",
                                    Status: "",
                                    DeletedFiles: [],
                                },
                                {
                                    ID: null, //blank for new. "19EB99B5-2B72-46A5-83B8-E0FDA0D5E4C9",
                                    Name: "Phase 4",
                                    DateFrom: "",
                                    DateTo: "",
                                    Status: "",
                                    DeletedFiles: [],
                                },
                                {
                                    ID: null, //blank for new. "19EB99B5-2B72-46A5-83B8-E0FDA0D5E4C9",
                                    Name: "Phase 5",
                                    DateFrom: "",
                                    DateTo: "",
                                    Status: "",
                                    DeletedFiles: [],
                                },
                                {
                                    ID: null, //blank for new. "19EB99B5-2B72-46A5-83B8-E0FDA0D5E4C9",
                                    Name: "Phase 6",
                                    DateFrom: "",
                                    DateTo: "",
                                    Status: "",
                                    DeletedFiles: [],
                                },
                            ],
                            DeletedPhases: [],
                        }),
                    });
                    const jsonData3 = await response3.json();
                    const response4 = await fetch(`${onboarding}/Deactivate`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        mode: "cors",
                        credentials: "include",
                        body: JSON.stringify([jsonData3.rows[0].id]),
                    });
                }
                const getScoreItems = await fetch(`${jobPositions}/SaveApplication`, {
                    method: "POST",
                    mode: "cors",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        applicantID: sortedData?.filter((item) => item.selected === true)[0]
                            .id,
                        jobPositionID: id,
                        status: 6,
                    }),
                });

                const response = await fetch(`${user}/GetSingle`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    mode: "cors",
                    credentials: "include",
                    body: JSON.stringify({
                        id: sortedData?.filter((item) => item.selected === true)[0].id,
                    }),
                });
                const jsonData = await response.json();
                if (jsonData.userRoles[0].roleID === applicantID) {
                    const response5 = await fetch(`${user}/DeleteRoles`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        mode: "cors",
                        credentials: "include",
                        body: JSON.stringify([`${jsonData.userRoles[0]?.id}`]),
                    });
                    const jsonData5 = await response5.json();
                    const response6 = await fetch(`${user}/SaveRole`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        mode: "cors",
                        credentials: "include",
                        body: JSON.stringify({
                            roleID: EmployeeRoleId,
                            userID: sortedData?.filter((item) => item.selected === true)[0]
                                .id,
                        }),
                    });
                    const jsonData6 = await response6.json();
                }
                sortedData
                    ?.filter((item) => item.selected === false && item.Status > 2)
                    .map(async (item) => {
                        const response3 = await fetch(`${jobPositions}/Hire`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            mode: "cors",
                            credentials: "include",
                            body: JSON.stringify({
                                applicantID: item.id,
                                hire: false,
                                jobPositionID: id,
                            }),
                        });
                        const getScoreItems = await fetch(
                            `${jobPositions}/SaveApplication`,
                            {
                                method: "POST",
                                mode: "cors",
                                credentials: "include",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    applicantID: item.id,
                                    jobPositionID: id,
                                    status: 3,
                                }),
                            }
                        );
                    });
                if (sessionStorage.getItem("PreQualificationTable")) {
                    const counter = JSON.parse(
                        sessionStorage.getItem("PreQualificationTable")
                    );
                    const updatedArray1 = counter.rows.map((item) => {
                        if (item.id === id) {
                            return { ...item, lastestHiredDate: new Date() };
                        }
                        return item;
                    });
                    sessionStorage.setItem(
                        "PreQualificationTable",
                        JSON.stringify({ rows: updatedArray1 })
                    );
                    document.cookie = `PrequaTablePage=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                }
                toast.success(
                    `You hired ${sortedData
                        ?.filter((item) => item.selected === true)[0]
                        .fullName.toUpperCase()}`
                );
                const updatedArray1 = sortedData
                    .filter((item) => item.Status > 2)
                    .map((item) => {
                        if (
                            item.id ===
                            sortedData?.filter((item) => item.selected === true)[0].id
                        ) {
                            return { ...item, hiredDate: new Date(), Status: 6 };
                        }
                        return { ...item, hiredDate: null, Status: 3 };
                    });
                setSortedData(updatedArray1);
            });
            //const response = await fetch(`${email}/Send`, {
            //  method: "POST",
            //  headers: { "Content-Type": "application/json" },
            //  mode: "cors",
            //  credentials: "include",
            //  body: JSON.stringify({
            //    body: message.replace(/\n/g, "<br>"),
            //    subject,
            //    to,
            //  }),
            //});
            //const data = await response.text();
            //if (data) {
            //  throw new Error("Failed to send email.");
            //}
        } catch (error) {
            //console.log(error.message);
            if (error.message === "Error fetching data") {
                if (sortedData?.filter((item) => item.selected === true).length === 0) {
                    toast.error("Select An Applicant.");
                } else {
                    toast.error("That Applicant is already hired");
                }
            }
            if (error.message === "Failed to send email") {
                toast.error("Failed to send email.");
            }
        } finally {
            setButtonPressed(false);
        }
    };

    const handleButtonUnhire = async () => {
        setButtonPressed(true);
        const ApplicantID = sortedData?.filter(
            (item) => item.selected === true && item.hiredDate
        );
        try {
            if (ApplicantID.length === 0) {
                throw new Error("Error fetching data");
            }
            let isNewEmployee = false;
            var results = await MySwal.fire({
                icon: "info",
                title: "Unhire Employee?",
                text: "Do you want to unhire this employee?",
                confirmButtonText: "Yes",
                cancelButtonText: "Cancel",
                showDenyButton: true,
                cancelButtonColor: "Red",
                denyButtonColor: "darkRed",
                confirmButtonColor: "green",
                allowOutsideClick: true,
                reverseButtons: false,
            });
            if (!results.isConfirmed)
                return;
            const response2 = await fetch(`${jobPositions}/Hire`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                mode: "cors",
                credentials: "include",
                body: JSON.stringify({
                    applicantID: sortedData?.filter((item) => item.selected === true)[0]
                        .id,
                    hire: false,
                    jobPositionID: id,
                }),
            });
            const response2Text = await response2.text();
            if (response2.ok) {
                toast.success('Employee was successfully unhired.');
                fetchData();
            } else {
                toast.error(response2Text);
                return;
            }
        } catch (error) {
            //console.log(error.message);
            if (error.message === "Error fetching data") {
                if (sortedData?.filter((item) => item.selected === true).length === 0) {
                    toast.error("Select An Applicant.");
                } else {
                    toast.error("That Applicant is not hired");
                }
            }
            if (error.message === "Failed to send email") {
                toast.error("Failed to send email.");
            }
        } finally {
            setButtonPressed(false);
        }
    }; // end const handleButtonUnhire = async () => {

    const sendEmail = async () => {
        try {
            const test = sortedData
                ?.filter((item) => item.email === to)
                .map(async (item) => {
                    const response = await fetch(`${email}/Send`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        mode: "cors",
                        credentials: "include",
                        body: JSON.stringify({
                            body: message.replace(/\n/g, "<br>"),
                            subject,
                            to: item.email,
                        }),
                    });
                    const data = await response.text();
                    if (data) {
                        throw new Error("Failed to send email.");
                    }
                    // const getScoreItems = await fetch(`${jobPositions}/SaveApplication`, {
                    //   method: "POST",
                    //   mode: "cors",
                    //   credentials: "include",
                    //   headers: {
                    //     "Content-Type": "application/json",
                    //   },
                    //   body: JSON.stringify({
                    //     applicantID: item.id,
                    //     jobPositionID: id,
                    //     status: 6,
                    //   }),
                    // });
                    // const data2 = await getScoreItems.json();
                });

            const updatedArray1 = sortedData.map((row) => {
                if (row.email === to) {
                    return { ...row };
                }
                return row;
            });
            setSortedData(updatedArray1);
            const rawr = await Promise.all(test);
        } catch (error) {
            console.log(error);
            throw new Error("Failed to send email.");
        } finally {
            setModalEmailIsOpen(false);
        }
    };
    const handleClick = async (e) => {
        try {
            const result = await toast.promise(
                sendEmail(),
                {
                    loading: "Sending...",
                    success: "Email Sent Successfully",
                    error: (error) => `${error.message}`,
                },
                {
                    style: {
                        zIndex: 99999,
                    },
                }
            );
            setTo("");
            setMessage("");
            setSubject("");
        } catch (error) { }
    };
    const userTasks = useSelector((state) => state.auth.userTasks)?.split(",");
    const applicantID = window.globalConfig.JOB_APPLICANT_ROLE;
    const [hiringIsPresent, setHiringIsPresentIsPresent] = useState(
        userTasks?.some((item) => item === "00000000-0000-0000-0000-000000000002")
    );
    const [decliningIsPresent, setDecliningIsPresentIsPresent] = useState(
        userTasks?.some((item) => item === "00000000-0000-0000-0000-000000000003")
    );
    useEffect(() => {
        setHiringIsPresentIsPresent(
            userTasks?.some((item) => item === "00000000-0000-0000-0000-000000000002")
        );
        setDecliningIsPresentIsPresent(
            userTasks?.some((item) => item === "00000000-0000-0000-0000-000000000003")
        );
    }, [userTasks]);
    
    const onHireClick = async (vApplicantID) => {
        try {
            var results = await MySwal.fire({
                icon: "info",
                title: "Hire Employee?",
                text: "Do you want to hire this employee?",
                confirmButtonText: "Yes",
                cancelButtonText: "Cancel",
                showDenyButton: true,
                cancelButtonColor: "Red",
                denyButtonColor: "darkRed",
                confirmButtonColor: "green",
                allowOutsideClick: true,
                reverseButtons: false,
            });
            if (!results.isConfirmed)
                return;
            var pResult = await fetchUtils.Post('/api/JobPositions/Hire', {
                hire: true,
                applicantID: vApplicantID,
                jobPositionID: id
            });
            if (!pResult.success)
                return;
            MySwal.fire({
                icon: "success",
                title: "Employee was successfully hired.",
                //text: "The status has been changed.",
                confirmButtonText: "Ok",
            });
            fetchData();
        } catch (e) {
            toast.error(e);
        }
    };

    const onUnhireClick = async (vApplicantID) => {
        try {
            var results = await MySwal.fire({
                icon: "info",
                title: "Unhire Employee?",
                text: "Do you want to unhire this employee?",
                confirmButtonText: "Yes",
                cancelButtonText: "Cancel",
                showDenyButton: true,
                cancelButtonColor: "Red",
                denyButtonColor: "darkRed",
                confirmButtonColor: "green",
                allowOutsideClick: true,
                reverseButtons: false,
            });
            if (!results.isConfirmed)
                return;
            var pResult = await fetchUtils.Post('/api/JobPositions/Hire', {
                hire: false,
                applicantID: vApplicantID,
                jobPositionID: id
            });
            if (!pResult.success)
                return;
            MySwal.fire({
                icon: "success",
                title: "Employee was successfully unhired.",
                //text: "The status has been changed.",
                confirmButtonText: "Ok",
            });
            fetchData();
        } catch (e) {
            toast.error(e);
        }
    };

    return (
        <>
            <div className="">
                {isLoading ? (
                    <Loadings />
                ) : (
                    <>
                        <div className="relative">
                            {buttonPressed ? (
                                <div className=" absolute top-0 left-0 w-full h-full bg-gray-500 z-999 opacity-20"></div>
                            ) : (
                                <></>
                            )}
                            <div className="bg-white rounded">
                                <div>
                                    {sortedData.filter((item) => item.Status > 2).length === 0 ? (
                                        <>
                                            <div className="block md:flex md:items-center md:justify-between">
                                                <div className="flex items-center gap-2 py-2">
                                                    <h1 className="font-semibold text-base">
                                                        Applicants for{" "}
                                                        <span className="uppercase">
                                                            {data?.rows[0].name} -{" "}
                                                        </span>
                                                        {data?.rows[0].plantillaItemNum}
                                                    </h1>
                                                </div>
                                            </div>

                                            <div className="relative flex flex-col min-w-0 break-words bg-white w-full shadow-lg rounded">
                                                <div className="hidden md:block w-full overflow-x-auto scrollbar-thin">
                                                    <table className="items-center bg-transparent table-fixed w-full border-b">
                                                        <thead className="bg-primary text-white">
                                                            <tr>
                                                                <th class="sticky left-0 z-30 bg-primary border-b-2 p-4 w-12 dark:border-dark-5 whitespace-nowrap font-normal text-gray-100"></th>
                                                                <th class="sticky left-12 z-30 bg-primary border-b-2 p-4 w-60 dark:border-dark-5 whitespace-nowrap font-normal text-gray-100">
                                                                    Name
                                                                </th>
                                                                {headers?.map((item) => (
                                                                    <th class="border-b-2 w-24 p-4 dark:border-dark-5 whitespace-nowrap font-normal text-gray-100 cursor-pointer">
                                                                        <TooltipPM
                                                                            text={`${item.label.split(":")[0]}`}
                                                                        >
                                                                            <h1 className="uppercase">
                                                                                {item.label.split(":")[1]}
                                                                            </h1>
                                                                        </TooltipPM>
                                                                    </th>
                                                                ))}
                                                                <th class="sticky right-96 z-30 border-b-2 p-4 w-24 dark:border-dark-5 font-normal bg-primary text-gray-100">
                                                                    Total Score
                                                                </th>
                                                                <th class="sticky right-72 z-30 border-b-2 p-4 w-24 dark:border-dark-5 whitespace-nowrap font-normal bg-primary text-gray-100">
                                                                    Rank
                                                                </th>
                                                                <th class="sticky right-48 z-30 border-b-2 p-4 w-24 dark:border-dark-5 whitespace-nowrap font-normal bg-primary text-gray-100">
                                                                    Status
                                                                </th>
                                                                <th class="sticky right-16 z-30  border-b-2 p-4 w-32 dark:border-dark-5 whitespace-nowrap font-normal bg-primary text-gray-100">
                                                                    Action
                                                                </th>
                                                                <th class="sticky right-0 z-30  border-b-2 p-4 w-16 dark:border-dark-5 whitespace-nowrap font-normal bg-primary text-gray-100"></th>
                                                            </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="border flex items-center justify-center py-4">
                                                <p className="text-2xl font-semibold">
                                                    No data available!
                                                </p>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="block md:flex md:items-center md:justify-between">
                                                <div className="flex items-center gap-2 py-2">
                                                    <h1 className="font-semibold text-base">
                                                        Applicants for{" "}
                                                        <span className="uppercase">
                                                            {data?.rows[0].name} -{" "}
                                                        </span>
                                                        {data?.rows[0].plantillaItemNum}
                                                    </h1>
                                                </div>
                                              
                                            </div>
                                            <div className="relative flex flex-col min-w-0 break-words bg-white w-full shadow-lg rounded">
                                                <div className="hidden md:block w-full overflow-x-auto scrollbar-thin">
                                                    <table className="items-center bg-transparent table-fixed w-full border-b">
                                                        <thead className="bg-primary text-white">
                                                            <tr>
                                                                <th class="sticky left-8 z-30  border-b-2 p-4 w-32 dark:border-dark-5 whitespace-nowrap font-normal bg-primary text-gray-100">
                                                                    Action
                                                                </th>
                                                                <th class="sticky left-12 z-30 bg-primary border-b-2 p-4 w-60 dark:border-dark-5 whitespace-nowrap font-normal text-gray-100">
                                                                    Name
                                                                </th>

                                                                <th class="border-b-2 w-24 p-4 dark:border-dark-5 whitespace-nowrap font-normal text-gray-100 cursor-pointer">
                                                                    <TooltipPM
                                                                        text=""
                                                                    >
                                                                        <h1 className="uppercase">
                                                                            PT
                                                                        </h1>
                                                                    </TooltipPM>
                                                                </th>

                                                                <th class="border-b-2 w-24 p-4 dark:border-dark-5 whitespace-nowrap font-normal text-gray-100 cursor-pointer">
                                                                    <TooltipPM
                                                                        text=""
                                                                    >
                                                                        <h1 className="uppercase">
                                                                            SM
                                                                        </h1>
                                                                    </TooltipPM>
                                                                </th>

                                                                <th class="border-b-2 w-24 p-4 dark:border-dark-5 whitespace-nowrap font-normal text-gray-100 cursor-pointer">
                                                                    <TooltipPM
                                                                        text=""
                                                                    >
                                                                        <h1 className="uppercase">
                                                                            BI
                                                                        </h1>
                                                                    </TooltipPM>
                                                                </th>

                                                                <th class="border-b-2 w-24 p-4 dark:border-dark-5 whitespace-nowrap font-normal text-gray-100 cursor-pointer">
                                                                    <TooltipPM
                                                                        text=""
                                                                    >
                                                                        <h1 className="uppercase">
                                                                            BEI
                                                                        </h1>
                                                                    </TooltipPM>
                                                                </th>

                                                                <th class="border-b-2 w-24 p-4 dark:border-dark-5 whitespace-nowrap font-normal text-gray-100 cursor-pointer">
                                                                    <TooltipPM
                                                                        text=""
                                                                    >
                                                                        <h1 className="uppercase">
                                                                            PSA
                                                                        </h1>
                                                                    </TooltipPM>
                                                                </th>

                                                                <th class="sticky right-96 z-30 border-b-2 p-4 w-24 dark:border-dark-5 font-normal bg-primary text-gray-100">
                                                                    Total Score
                                                                </th>
                                                                <th class="sticky right-72 z-30 border-b-2 p-4 w-24 dark:border-dark-5 whitespace-nowrap font-normal bg-primary text-gray-100">
                                                                    Rank
                                                                </th>
                                                                <th class="sticky right-48 z-30 border-b-2 p-4 w-24 dark:border-dark-5 whitespace-nowrap font-normal bg-primary text-gray-100">
                                                                    Status
                                                                </th>

                                                                <th class="sticky right-0 z-30  border-b-2 p-4 w-16 dark:border-dark-5 whitespace-nowrap font-normal bg-primary text-gray-100"></th>
                                                            </tr>
                                                        </thead>

                                                        <tbody className="border-b">
                                                            {consolidated.applicants
                                                                ?.map((item) => (
                                                                    <tr>
                                                                        <td class="sticky right-16 bg-white z-9 border-b-2 p-2">
                                                                            <div className="flex items-center justify-center">
                                                                                {item.status == 'Hired' ?
                                                                                    <button
                                                                                        className="bg-red-500 hover:bg-green-700 rounded-sm py-0.5 px-3 text-white"
                                                                                        onClick={() =>
                                                                                            onUnhireClick(item.applicantID)
                                                                                            // navigate(
                                                                                            //     `/Qualified-Applicants-Scoring/${id}/${item.applicantID}`
                                                                                            // )
                                                                                        }
                                                                                    >
                                                                                        Unhire
                                                                                    </button>
                                                                                    : !hasHired &&
                                                                                    <button
                                                                                        className="bg-green-500 hover:bg-green-700 rounded-sm py-0.5 px-3 text-white"
                                                                                        onClick={() =>
                                                                                            onHireClick(item.applicantID)
                                                                                            // navigate(
                                                                                            //     `/Qualified-Applicants-Scoring/${id}/${item.applicantID}`
                                                                                            // )
                                                                                        }
                                                                                    >
                                                                                        Hire
                                                                                    </button>
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                        <th class="sticky left-12 bg-white z-9 border-b-2 uppercase text-sm text-center p-2">
                                                                            {item.applicantName}
                                                                        </th>

                                                                        <td class="border-b-2 text-center z-9 p-2 text-sm dark:border-dark-5">
                                                                            {Math.round(item.categories.PT * 100) / 100}
                                                                        </td>

                                                                        <td class="border-b-2 text-center z-9 p-2 text-sm dark:border-dark-5">
                                                                            {Math.round(item.categories.SM * 100) / 100}
                                                                        </td>

                                                                        <td class="border-b-2 text-center z-9 p-2 text-sm dark:border-dark-5">
                                                                            {Math.round(item.categories.BI * 100) / 100}
                                                                        </td>

                                                                        <td class="border-b-2 text-center z-9 p-2 text-sm dark:border-dark-5">
                                                                            {Math.round(item.categories.BEI * 100) / 100}
                                                                        </td>

                                                                        <td class="border-b-2 text-center z-9 p-2 text-sm dark:border-dark-5">
                                                                            {Math.round(item.categories.PSA * 100) / 100}
                                                                        </td>

                                                                        <td class="sticky right-96 bg-white z-9 border-b-2  text-center p-2 dark:border-dark-5">
                                                                            <p className="text-sm">
                                                                                {Math.round(item.total * 100) / 100}
                                                                            </p>
                                                                        </td>{" "}
                                                                        <td class="sticky right-72 bg-white z-9 border-b-2  text-center p-2 dark:border-dark-5">
                                                                            <p className="text-sm">
                                                                                {item.rank}
                                                                            </p>
                                                                        </td>{" "}
                                                                        <th class="sticky right-48 bg-white z-99 border-b-2 text-sm text-center p-2 dark:border-dark-5">
                                                                            {item.status == 'Hired' ? (
                                                                                <p className="text-green-500 font-semibold">
                                                                                    Hired
                                                                                </p>
                                                                            ) : item.status == 'Declined' ? (
                                                                                <p className="text-red-500 font-semibold">
                                                                                    Declined
                                                                                </p>
                                                                            ) : item.Status == 'Pending Reply' ? (
                                                                                <p className="text-yellow-500 font-semibold">
                                                                                    Pending Reply
                                                                                </p>
                                                                            ) : (
                                                                                <></>
                                                                            )}
                                                                        </th>{" "}
                                                                        {/* <td class="sticky right-64 bg-white z-9 border-b-2 text-center p-2 dark:border-dark-5">
                                        <span
                                          style={{
                                            color:
                                              item.Status > 0
                                                ? "green"
                                                : item.disqualifiedDate
                                                ? "red"
                                                : "orange",
                                          }}
                                        >
                                          <h1 className="font-semibold">
                                            {item.Status % 10 > 4 ||
                                            item.Status % 10 === 3
                                              ? "Email Sent"
                                              : ""}
                                          </h1>
                                        </span>
                                      </td> */}

                                                                        
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div className="block md:hidden">
                                        {sortedData
                                            ?.filter((item) => item.Status > 2)
                                            ?.slice(
                                                indexOfFirstRow,
                                                //sortAndSlice ? sortAndSlice :
                                                indexOfLastRow
                                            )
                                            ?.sort(
                                                (personA, personB) =>
                                                    personB.PracticalScore - personA.PracticalScore
                                            )
                                            ?.map((item) => (
                                                <div className="bg-white rounded border border-gray-800 shadow-2 p-4">
                                                    <div className="flex items-start justify-start">
                                                        <input
                                                            type="checkbox"
                                                            checked={item.selected}
                                                            onChange={() => toggleSelected(item.id)}
                                                        />
                                                    </div>
                                                    <div className="grid grid-cols-3 pt-1">
                                                        <div className="col-span-1">
                                                            <h1>Name</h1>
                                                        </div>
                                                        <div className="col-span-2">
                                                            <h1 className="whitespace-nowrap uppercase">
                                                                {item.fullName}
                                                            </h1>
                                                        </div>
                                                    </div>
                                                    <div className="grid grid-cols-3 pt-1">
                                                        <div className="col-span-1">
                                                            <h1>Interview Score</h1>
                                                        </div>
                                                        <div className="col-span-2">{item.Interview}</div>
                                                    </div>
                                                    <div className="grid grid-cols-3 pt-1">
                                                        <div className="col-span-1">
                                                            <h1>Pen Test</h1>
                                                        </div>
                                                        <div className="col-span-2">{item.PenTest}</div>
                                                    </div>
                                                    <div className="grid grid-cols-3 pt-1">
                                                        <div className="col-span-1">
                                                            <h1>Background Investigation</h1>
                                                        </div>
                                                        <div className="col-span-2">{item.BI}</div>
                                                    </div>
                                                    <div className="grid grid-cols-3 pt-1">
                                                        <div className="col-span-1">
                                                            <h1>Hands-On</h1>
                                                        </div>
                                                        <div className="col-span-2">{item.HandsOn}</div>
                                                    </div>
                                                    <div className="grid grid-cols-3 pt-1">
                                                        <div className="col-span-1">
                                                            <h1>Performance</h1>
                                                        </div>
                                                        <div className="col-span-2">{item.Performance}</div>
                                                    </div>
                                                    <div className="grid grid-cols-3 pt-1">
                                                        <div className="col-span-1">
                                                            <h1>Total Score</h1>
                                                        </div>
                                                        <div className="col-span-2">
                                                            {item.PracticalScore}
                                                        </div>
                                                    </div>
                                                    <div className="grid grid-cols-3 pt-1">
                                                        <div className="col-span-1">
                                                            <h1>Rank</h1>
                                                        </div>
                                                        <div className="col-span-2">
                                                            {sortAndSlice
                                                                ?.filter((row) => row.id === item.id)
                                                                .map((row) => (
                                                                    <>{row.rank}</>
                                                                ))}
                                                        </div>
                                                    </div>
                                                    <div className="grid grid-cols-3 pt-1">
                                                        <div className="col-span-1">
                                                            <h1>Status</h1>
                                                        </div>
                                                        <div className="col-span-2">
                                                            <span>
                                                                <h1 className="font-semibold md:font-normal">
                                                                    {item.hiredDate ? (
                                                                        <p className="text-green-500">Hired</p>
                                                                    ) : item.Status === 3 ? (
                                                                        <p className="text-red-500">Declined</p>
                                                                    ) : item.Status === 5 ? (
                                                                        <p className="text-yellow-500">
                                                                            Pending Reply
                                                                        </p>
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                </h1>
                                                            </span>
                                                        </div>
                                                    </div>{" "}
                                                    {/* <div className="grid grid-cols-3 pt-1">
                              <div className="col-span-1">
                                <h1>Email Status</h1>
                              </div>
                              <div className="col-span-2">
                                <span
                                  style={{
                                    color:
                                      item.Status > 0
                                        ? "green"
                                        : item.disqualifiedDate
                                        ? "red"
                                        : "orange",
                                  }}
                                >
                                  <h1 className="font-semibold">
                                    {item.Status > 4 || item.Status === 3
                                      ? "Email Sent"
                                      : ""}
                                  </h1>
                                </span>
                              </div>
                            </div> */}
                                                    <div className="grid grid-cols-3 pt-1">
                                                        <div className="col-span-1">
                                                            <h1>Score</h1>
                                                        </div>
                                                        <div className="col-span-2">
                                                            <button
                                                                className="bg-green-600 hover:bg-green-800 px-5 py-1 text-white rounded"
                                                                onClick={() =>
                                                                    navigate(
                                                                        `/Qualified-Applicants-Scoring/${id}/${item.id}`
                                                                    )
                                                                }
                                                            >
                                                                Give Score
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="grid grid-cols-3 pt-1">
                                                        <div className="col-span-1">
                                                            <h1>Email</h1>
                                                        </div>
                                                        <div className="col-span-2">
                                                            <button
                                                                className="bg-green-600 hover:bg-green-800 px-5 py-1 text-white rounded"
                                                                onClick={() => (
                                                                    setModalEmailIsOpen(true), setTo(item.email)
                                                                )}
                                                            >
                                                                Send Email
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>

                                    <div className="block">
                                        <div className="flex items-center justify-between py-2">
                                            <div>
                                                <p className="mb-2 text-sm italic">
                                                    Count:{" "}
                                                    {sortedData?.filter((item) => item.Status > 2).length}
                                                </p>
                                            </div>
                                            <div className="flex items-center gap-2">
                                                <label className="mb-2 flex items-center text-sm italic">
                                                    Rows Per Page:
                                                    <select
                                                        value={rowsPerPage}
                                                        onChange={handleRowsPerPage}
                                                        className="ml-2 p-1 text-sm border-none italic bg-transparent focus:outline-none focus:ring-0"
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </label>
                                                <div className="flex items-center justify-end mb-2 gap-5">
                                                    <button
                                                        onClick={handleBackPage}
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FiChevronLeft className="w-4 h-4" />
                                                    </button>
                                                    <button
                                                        onClick={handleNextPage}
                                                        disabled={
                                                            currentPage === Math.ceil(rowCount / rowsPerPage)
                                                        }
                                                    >
                                                        <FiChevronRight className="w-4 h-4" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>

            <PrequaliModal
                modalIsOpen={modalIsOpen}
                handleButtonClick={handleButtonClick}
                handleSubmit={handleQualify}
                to={to}
                setTo={setTo}
                subject={subject}
                setSubject={setSubject}
                message={message}
                setMessage={setMessage}
                handleCloseModal={handleCloseModal}
            />
            <HireModal
                modalIsOpen={modalHireIsOpen}
                handleButtonClick={handleButtonClick}
                handleSubmit={handleHire}
                to={to}
                setTo={setTo}
                subject={subject}
                setSubject={setSubject}
                message={message}
                setMessage={setMessage}
                handleCloseModal={handleCloseModal}
            />
            <DeclineModal
                modalIsOpen={modalDeclineIsOpen}
                handleButtonClick={handleButtonClick}
                handleSubmit={handleDeclined}
                to={to}
                setTo={setTo}
                subject={subject}
                setSubject={setSubject}
                message={message}
                setMessage={setMessage}
                handleCloseModal={handleCloseModal}
            />
            <RejectOthersModal
                modalIsOpen={modalOthersIsOpen}
                handleButtonClick={handleButtonClick}
                handleSubmit={handleDeclinedOthers}
                to={to}
                setTo={setTo}
                subject={subject}
                setSubject={setSubject}
                message={message}
                setMessage={setMessage}
                handleCloseModal={handleCloseModal}
            />
            <RemoveModal
                modalIsOpen={modalRemoveIsOpen}
                handleSubmit={handleRemove}
                to={to}
                setTo={setTo}
                subject={subject}
                setSubject={setSubject}
                message={message}
                setMessage={setMessage}
                handleCloseModal={handleCloseModal}
            />
            <EmailModal
                modalIsOpen={modalEmailIsOpen}
                handleSubmit={handleClick}
                to={to}
                setTo={setTo}
                subject={subject}
                setSubject={setSubject}
                message={message}
                setMessage={setMessage}
                handleCloseModal={handleCloseModal}
            />
        </>
    );
}
